<template>
  <moe-page>
    <moe-top></moe-top>
    <!-- <div class="top_total flex Flexalign Flexjustify">
      <div class="top_total_box flex FlexAround">
        <div class="total_one flex Flexalign" v-for="(item, index) in totalList" :key="index">
          <div>
            <el-image class="total_icon" :src="imgPath(item.icon)"></el-image>
          </div>
          <div class="flex FlexBaseline">
            <div class="total_value">{{ item.value }}</div>
            <div class="total_text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!--  -->

    <div class="flex Flexjustify Flexalign top_banner_box">
      <div class="top_banner flex FlexBetween">
        <div class="top_banner_left">
          <div class="course_classify">
            <div class="menu_outer_box flex FlexAround">
              <template v-for="(v, k) in stageList" :key="k">
                <div class="menu_box cursor_pointer" :class="{ active: v.stageId == selectedInfo.stageId }"
                  @click="changeStage(v, k)">
                  <div class="text">{{ v.stageName }}</div>
                  <div class="baseline"></div>
                </div>
              </template>
            </div>
          </div>

          <div class="course_list_box">
            <div v-for="(item, index) in subjectList" :key="index" :class="[
              'course_one',
              item.subjectId == selectedInfo.subjectId ? 'active_back' : '',
            ]" @click="selectSubject(item.subjectId)">
              <div class="course_one_text cursor_pointer" @mouseenter="showSubjectMore(item.subjectId)"
                @mouseleave="hideSubjectMore">
                {{ item.subjectName }}
              </div>
            </div>
          </div>
        </div>
        <!-- 筛选项 -->
        <div class="subject_benefits" @mouseenter="showSubjectMore1(true)" @mouseleave="hideSubjectMore"
          v-if="isOpenSubject">
          <div class="benefits_title">版本</div>
          <div class="flex FlexWrap">
            <div :class="[
              selectedInfo.publisherId == '' ? 'selected_active' : '',
              'publish_one',
              'mar_top_10',
            ]" class="cursor_pointer" @mouseenter="selectePublish('')" @click="selectePublish('', true)">
              不限
            </div>
            <div v-for="(item, index) in publisherList" :key="index" :class="[
              selectedInfo.publisherId == item.publisherId ? 'selected_active' : '',
              'publish_one',
              'mar_top_10',
            ]" class="cursor_pointer" @mouseenter="selectePublish(item.publisherId)"
              @click="selectePublish(item.publisherId, true)">
              {{ item.publisherName }}
            </div>
          </div>
          <div class="benefits_title mar_top_10">学册</div>
          <div class="flex FlexWrap">
            <div :class="[
              selectedInfo.termId == '' ? 'selected_active' : '',
              'publish_one',
              'mar_top_10',
            ]" class="cursor_pointer" @mouseenter="selecteTerm('')" @click="selecteTerm('', true)">
              不限
            </div>
            <div v-for="(item, index) in termList" :key="index" :class="[
              selectedInfo.termId == item.termId ? 'selected_active' : '',
              'publish_one',
              'mar_top_10',
            ]" class="cursor_pointer" @mouseenter="selecteTerm(item.termId)" @click="selecteTerm(item.termId, true)">
              {{ item.termName }}
            </div>
          </div>
          <div class="benefits_title mar_top_10">难度</div>
          <div class="flex FlexWrap">
            <div :class="[
              selectedInfo.courseDifficulty == '' ? 'selected_active' : '',
              'publish_one',
              'mar_top_10',
            ]" class="cursor_pointer" @mouseenter="selecteDifficulty('')" @click="selecteDifficulty('', true)">
              不限
            </div>
            <div v-for="(item, index) in difficultyList" :key="index" :class="[
              selectedInfo.courseDifficulty == item.difficultyId
                ? 'selected_active'
                : '',
              'publish_one',
              'mar_top_10',
            ]" class="cursor_pointer" @mouseenter="selecteDifficulty(item.difficultyId)"
              @click="selecteDifficulty(item.difficultyId, true)">
              {{ item.difficultyName }}
            </div>
          </div>
        </div>

        <div class="top_banner_center">
          <el-carousel :interval="4000" :arrow="imageList.length > 1 ? 'always' : 'never'" indicator-position="none">
            <el-carousel-item v-for="(image, index) in imageList" :key="index">
              <img :src="imgPath(image.picture)" alt="carousel image"
                style="width: 100%; height: 100%; border-radius: 10px" @click="goBannerLink(image.link)" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="top_banner_right_new flex flexcolumn FlexBetween">
          <div class="top_banner_right flex flexcolumn">
            <div class="flex flexcolumn Flexalign FlexEvenly top_banner_right_top">
              <div class="flex Flexalign user_info">
                <el-avatar :size="42" :src="imgPath(userInfo.headImage || 'default_avatar.png')" />
                <div class="register_text flex-1 toverflow">
                  {{ userInfo.buyerUserId ? userInfo.name : "Hi~注册有礼" }}
                </div>
              </div>
              <div class="btn btn_login cursor_pointer" @click="loginBtn">
                {{ userInfo.buyerUserId ? "我的课程" : "登陆/注册" }}
              </div>
            </div>
            <div class="top_banner_right_bottom flex-1 flex FlexEvenly flexcolumn">
              <div class="newest_course">最新课程</div>
              <!-- <div class="active_course">千门课免费</div>
            <div class="active_course">冲刺心仪证书</div>
            <div class="active_course">海量题库</div>
            <div class="active_course">一手备考经验</div>
            <div class="active_course">函数解析</div> -->
              <div v-for="(item, index) in newCourseList" :key="index" class="toverflow cursor_pointer"
                @click="goDetail(item)" @mouseenter="showHighColor(item)" @mouseleave="hideHighColor">
                <el-tooltip class="box-item" :content="item.courseName" placement="right" effect="customized"
                  :show-after="1000" :show-arrow="false">
                  <div :class="[
                    selectNewCourseId == item.courseId
                      ? 'active_course'
                      : 'active_normal',
                  ]">
                    {{ item.courseName }}
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="task_box">
            <div class="task_title ml-10 mt-15">做任务领好礼</div>
            <div class="task_btn mt-10 ml-10 cursor_pointer" @click="finishTask">
              去完成
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hot_sell_course flex Flexjustify Flexalign flexcolumn">
      <div class="hot_sell_course_top FlexBetween flex Flexalign">
        <div class="flex Flexalign">
          <div class="hot_sell_course_top_title">为你推荐</div>
        </div>
        <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goCourseList">
          更多
          <div class="flex Flexalign" style="margin-left: 5px">
            <el-icon :size="18">
              <ArrowRight color="RGBA(70, 221, 187, 1)" />
            </el-icon>
          </div>
        </div>
      </div>
      <courseList :selectedInfo="courseRecommendSelectedInfo" :showPagination="false"></courseList>
    </div>

    <div class="course_rank flex Flexjustify Flexalign flexcolumn">
      <div class="week_course_rank">本周课程排行</div>
      <courseRankList></courseRankList>
    </div>
    <div class="hot_sell_course flex Flexjustify Flexalign flexcolumn">
      <div class="hot_sell_course_top FlexBetween flex Flexalign">
        <div class="flex Flexalign">
          <div class="hot_sell_course_top_title">热销好课</div>
          <div v-for="(item, index) in hotCourseList" :key="index" :class="[
            item.subjectId == courseHotSelectedInfo.subjectId ? 'active_text' : '',
            'hot_course_text',
            'cursor_pointer', 'hot_course_hover'
          ]" @click="changeHot(item)">
            {{ item.subjectName }}
          </div>
        </div>
        <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goCourseList">
          更多
          <div class="flex Flexalign" style="margin-left: 5px">
            <el-icon :size="18">
              <ArrowRight color="RGBA(70, 221, 187, 1)" />
            </el-icon>
          </div>
        </div>
      </div>
      <courseList :selectedInfo="courseHotSelectedInfo" :showPagination="false"></courseList>
    </div>
    <div class="course_rank flex Flexjustify Flexalign flexcolumn" v-if="examinationTotalNum > 0">
      <div class="week_course_rank flex Flexalign FlexBetween">
        <div>试卷</div>
        <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goExamination">
          全部试卷
          <div class="flex Flexalign" style="margin-left: 5px">
            <el-icon :size="18">
              <ArrowRight color="RGBA(70, 221, 187, 1)" />
            </el-icon>
          </div>
        </div>
      </div>
      <paperCategory></paperCategory>
    </div>
    <moe-bottom></moe-bottom>
    <moe-right></moe-right>
    <login ref="login"></login>
  </moe-page>
</template>
<script>
import courseList from "@/components/index/courseList.vue";
import courseRankList from "@/components/index/courseRankList.vue";
import login from "@/components/popup/login.vue";
import paperCategory from "@/components/examinationPaper/paperCategory.vue";
import AMapLoader from "@amap/amap-jsapi-loader";
import area from "@/assets/data/area";
import { onConnectGoeasy } from "@/assets/utils/goeasy.js";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Index",
  components: {
    courseList,
    courseRankList,
    login,
    paperCategory,
  },
  data() {
    return {
      totalList: [
        {
          icon: "top_icon1.png",
          value: "",
          field: "businessNum",
          text: "家合作机构",
        },
        {
          icon: "top_icon2.png",
          value: "",
          field: "buyerUserNum",
          text: "人在线学",
        },
        {
          icon: "top_icon3.png",
          value: "",
          field: "courseNum",
          text: "项优质课程",
        },
      ],
      imageList: [],
      hotCourseList: [],
      hotCourseValue: 0,
      isOpenSubject: false,
      subelementShow: false,
      selectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: 5, // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 8, // 单页数量
        orderByColumn: "", // 排序字段
        isAsc: "desc", //升降序
        typeId: "",
      },
      courseHotSelectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 8, // 单页数量
        orderByColumn: "hot_sales",
        isAsc: "desc",
        typeId: "",
      },
      courseRecommendSelectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 8, // 单页数量
        typeId: "",
      },
      subjectList: [],
      termList: [],
      publisherList: [],
      location: {},
      selectedCityInfo: {
        cityName: "",
        cityId: "",
      },
      newCourseList: [],
      selectNewCourseId: "",
      examinationTotalNum: 0, // 试卷数
    };
  },
  computed: {
    ...mapState({
      stageList: (state) => state.filter.stageList,
      // subjectList: (state) => state.filter.subjectList,
      // publisherList: (state) => state.filter.publisherList,
      // termList: (state) => state.filter.termList,
      difficultyList: (state) => state.filter.difficultyList,
      userInfo: (state) => state.userInfo,
      selectArea: (state) => state.area.selectArea,
      selectCourseType: (state) => state.user.selectCourseType,
      courseTypeList: (state) => state.filter.courseTypeList,
    }),
  },
  watch: {
    selectCourseType: {
      handler(value) {
        this.courseRecommendSelectedInfo.typeId = value;
        this.courseHotSelectedInfo.typeId = value;
        this.selectedInfo.typeId = value;
        this.getCourseList();
        this.getBannerList();
      },
      deep: true,
      immediate: true,
    },
    stageList: {
      handler(value) {
        if (!this.$Tools.empty(value)) {
          this.changeStage(this.stageList[0]);
          this.getPublisher();
          this.initFilter();
          // this.subjectList = this.$store.state.filter.subjectList;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.getLocation();
    this.getHomeData();
    this.getBannerList();
    onConnectGoeasy()//连接goEasy
    // 初始化筛选项
    // this.initFilter();
    this.getCourseSubjectList();
    this.getCourseList();
    // this.changeStage({ stageId: "5", stageName: "小学" }); // 初始默认小学学段
    // 为你推荐绑定兴趣爱好所选学段/学科
    this.courseRecommendSelectedInfo.orderByAtStagelds = this.userInfo.atStageIds;
    this.courseRecommendSelectedInfo.orderByAtSubjectlds = this.userInfo.atSubjectIds;
    this.getPhaseList();
    this.getFamilyTree();
    this.getExaminationList();
  },

  methods: {
    showHighColor(info) {
      this.selectNewCourseId = info.courseId;
    },
    hideHighColor() {
      this.selectNewCourseId = "";
    },
    finishTask() {
      this.$Jump.href("/integralCenter");
    },
    // 家庭关系列表
    getFamilyTree() {
      this.$Api.user
        .getFamilyTree({ userType: 2 })
        .then((res) => {
          this.$store.commit("user/setRelationshipOptions", res.data.data);
        })
        .catch(() => { });
    },
    // 阶段字典列表
    getPhaseList() {
      this.$Api.course
        .getPhaseList()
        .then((res) => {
          // 设置缓存
          this.$store.commit("learning/setPhaseList", res.data.data);
        })
        .catch(() => { });
    },
    // 获取最新课程
    getCourseList() {
      let selectedInfo = {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 2, // 单页数量
        orderByColumn: "", // 排序字段
        isAsc: "desc", //升降序
        orderByAtStagelds: this.userInfo.atStageIds, // 用户所属学段
        orderByAtSubjectlds: this.userInfo.atSubjectIds, // 用户兴趣爱好所选学科
        typeId: this.selectCourseType,
      };
      this.$Api.course
        .getCourseList(selectedInfo)
        .then((res) => {
          // // 加个判断是否返回指定条数数据，未满足重新掉接口（去掉兴趣爱好关联）
          // if (res.data.data.list?.length != selectedInfo.pageSize) {
          //   delete selectedInfo.stageIds;
          //   delete selectedInfo.subjectIds;
          //   this.$Api.course
          //     .getCourseList(selectedInfo)
          //     .then((res) => {
          //       this.newCourseList = res.data.data.list;
          //     })
          //     .catch(() => {});
          // } else {
          this.newCourseList = res.data.data.list;
          // }
        })
        .catch(() => { });
    },
    // 详情
    goDetail(info) {
      this.$Jump.href("/courseDetail", { courseId: info.courseId });
    },
    // 获取上架课程的学科列表
    getCourseSubjectList() {
      this.$Api.course
        .getCourseSubjectList()
        .then((res) => {
          this.hotCourseList = res.data.data;
        })
        .catch(() => { });
    },
    changeHot(info) {
      if (info.subjectId == this.courseHotSelectedInfo.subjectId) {
        this.courseHotSelectedInfo.subjectId = "";
      } else {
        this.courseHotSelectedInfo.subjectId = info.subjectId;
      }
    },
    changeRecommend(info) {
      if (info.subjectId == this.courseRecommendSelectedInfo.subjectId) {
        this.courseRecommendSelectedInfo.subjectId = "";
      } else {
        this.courseRecommendSelectedInfo.subjectId = info.subjectId;
      }
    },
    // 获取banner轮播图
    getBannerList() {
      let bannerId = 3;
      if (this.selectCourseType == 1) {
        bannerId = 12;
      }
      if (this.selectCourseType == 2) {
        bannerId = 15;
      }
      if (this.selectCourseType == 3) {
        bannerId = 18;
      }
      this.$Api.common
        .getBannerList({ id: bannerId })
        .then((res) => {
          this.imageList = res.data.data;
        })
        .catch(() => { });
    },
    goBannerLink(link) {
      if (link) {
        window.open(link);
      }
    },
    // 定位
    getLocation() {
      if (this.selectArea.cityName) return;
      // 判断浏览器是否支持获取位置信息
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.location.latitude = position.coords.latitude;
            this.location.longitude = position.coords.longitude;
            // 根据经纬度获取所在地区
            if (this.location.latitude) {
              this.getAreaInfo();
            }
          },
          (error) => {
            let message = "";
            switch (error.code) {
              case error.PERMISSION_DENIED:
                message = "用户拒绝对获取地理位置的请求。";
                break;
              case error.POSITION_UNAVAILABLE:
                message = "位置信息是不可用的。";
                break;
              case error.TIMEOUT:
                message = "请求用户地理位置超时。";
                break;
              case error.UNKNOWN_ERROR:
                message = "未知错误。";
                break;
              default:
                message = error.mesaage;
            }
            // if (error.code == error.PERMISSION_DENIED) {
            // msg = '请开启浏览器定位权限（设置>隐私>位置服务）';
            // }
            this.$Dialog.toast(`获取失败：${message}`, { type: "error" });
            // 新增查询地址接口（初略位置）
            fetch("https://ipapi.co/json/")
              .then((response) => response.json())
              .then((data) => {
                this.location.latitude = data.latitude;
                this.location.longitude = data.longitude;
                this.getAreaInfo();
              });
          },
          { enableHighAccuracy: true, timeout: 50000 } // 高精度模式，5秒超时
        );
      } else {
        this.$Dialog.toast(`当前浏览器不支持地理位置功能`, { type: "error" });
      }
    },
    // 根据定位获取所在地区
    getAreaInfo() {
      window._AMapSecurityConfig = {
        securityJsCode: "3fa6ab5f7802a694dcaa691024b7adbc",
      };
      AMapLoader.load({
        key: "1cfe6807e078c7da12ff9d6a281fd863", //申请好的 Web 端开发者 Key，首次调用 load 时必填
        version: "2.0", //指定要加载的 JS API 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['AMap.Scale','...','...']
      })
        .then((AMap) => {
          //引入插件，此示例采用异步引入，更多引入方式 https://lbs.amap.com/api/javascript-api-v2/guide/abc/plugins
          AMap.plugin("AMap.Geocoder", () => {
            var geocoder = new AMap.Geocoder({
              city: "010", // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            });

            var lnglat = [this.location.longitude, this.location.latitude];

            geocoder.getAddress(lnglat, (status, result) => {
              if (status === "complete" && result.info === "OK") {
                // result为对应的地理位置详细信息
                let cityList = area.city_list;
                // 遍历城市获取城市id信息
                for (let key in cityList) {
                  if (cityList[key] == result.regeocode.addressComponent.city) {
                    this.selectedCityInfo.cityName = cityList[key];
                    this.selectedCityInfo.cityId = key;
                  }
                }
                // 定位失败则默认显示北京
                if (!this.selectedCityInfo.cityId) {
                  this.selectedCityInfo.cityName = "北京市";
                  this.selectedCityInfo.cityId = 110100;
                }
              }
              this.$store.commit("area/setReady", this.selectedCityInfo);
            });
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loginBtn() {
      // 判断是否登录
      if (this.userInfo.buyerUserId) {
        this.$Jump.href("/learningCenter");
      } else {
        // this.$refs.login.showLogin = true;
        // 统一走 Vuex，避免 ref 未挂载时报错
        this.$store.commit("setShowLogin", true);
      }
    },
    initFilter() {
      this.selectedInfo.stageId = this.stageList[0]?.stageId;
      this.selectedInfo.subjectId = this.subjectList[0]?.subjectId;
    },
    changeStage(info) {
      this.selectedInfo.stageId = info.stageId;
      this.$Api.common
        .getSubject({ stageId: this.selectedInfo.stageId })
        .then((res) => {
          this.subjectList = res.data.data;
        })
        .catch((err) => {
          console.log(err.message);
        });
      this.$Api.common
        .getTerm({ stageId: this.selectedInfo.stageId })
        .then((res) => {
          this.termList = res.data.data;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    // 获取顶部数据统计
    getHomeData() {
      this.$Api.home
        .getHomeData()
        .then((res) => {
          this.totalList.forEach((item) => {
            item.value = res.data.data[item.field];
          });
        })
        .catch(() => { });
    },
    // 学科更多弹窗
    showSubjectMore(subjectId) {
      this.isOpenSubject = true;
      // console.log(subelement)
      // if (subelement) this.subelementShow = true;
      if (subjectId) this.selectedInfo.subjectId = subjectId;
      this.getPublisher();
    },
    getPublisher() {
      this.$Api.common
        .getPublisher({ subjectId: this.selectedInfo.subjectId })
        .then((res) => {
          this.publisherList = res.data.data;
        })
        .catch(() => { });
    },
    showSubjectMore1() {
      this.isOpenSubject = true;
    },
    hideSubjectMore() {
      // setTimeout(() => {
      // if (!this.subelementShow) {
      this.isOpenSubject = false;
      // } else {
      // this.subelementShow = false;
      // }
      // }, 500)
    },
    // 版本选择
    selectePublish(value, type) {
      this.selectedInfo.publisherId = value;
      if (type) {
        this.goCourseList();
      }
    },
    // 学期选择
    selecteTerm(value, type) {
      this.selectedInfo.termId = value;
      if (type) {
        this.goCourseList();
      }
    },
    // 难度选择
    selecteDifficulty(value, type) {
      this.selectedInfo.courseDifficulty = value;
      if (type) {
        this.goCourseList();
      }
    },
    // 学科选择
    selectSubject(value) {
      this.selectedInfo.subjectId = value;
      this.isOpenSubject = true;
    },
    // 课程列表页
    goCourseList() {
      this.$Jump.href("/courseList", {
        selectedParams: JSON.stringify(this.selectedInfo),
      });
    },
    // 试卷中心
    goExamination() {
      this.$Jump.href("/examinationCenter", {
        topSelectedMenu: 6,
      });
    },
    // 获取试卷数量
    getExaminationList() {
      this.$Api.examination.getExaminationList().then(res => {
        this.examinationTotalNum = res.data.data.total;
      }).catch(() => { })
    }
  },
};
</script>
<style lang="scss" scoped>
.btn {
  width: 140px;
  height: 36px;
  background: linear-gradient(90deg, #00d5c2, #00d498);
  border-radius: 18px;
  color: #fff;
  line-height: 36px;
  text-align: center;
}

.user_info {
  width: 140px;
}

.top_total {
  width: 100%;
  // background: linear-gradient(to bottom, #abdcd0, #f3f3f3);
  background: #f5f6f8;

  .top_total_box {
    width: $pageMainWidth;
    margin: 20px 0;

    .total_one {
      .total_icon {
        width: 87px;
        height: 87px;
      }

      .total_value {
        // margin-left: 6px;
        font-size: 26px;
        font-weight: 500;
      }

      .total_text {
        color: #666666;
        margin-left: 2px;
      }
    }
  }
}

.top_banner_box {
  width: 100%;
  padding: 40px 0 40px 0;
  // background: rgba(243, 243, 243, 1);
  background: #f5f6f8;

  .top_banner {
    width: $pageMainWidth;
    position: relative;

    .course_classify {
      width: 200px;
      height: 38px;
      background: linear-gradient(90deg, #00d5c2 0%, #00d498 100%);
      border-radius: 10px 10px 0px 0px;
      box-sizing: border-box;

      .menu_outer_box {
        display: flex;
        align-items: center;
        // justify-content: space-around;
        height: 38px;
        // box-sizing: border-box;
        touch-action: pan-x;
        /* 允许垂直滚动 */
        overflow-x: auto;
        scrollbar-width: none;
        /* 隐藏Firefox滚动条 */
        -ms-overflow-style: none;
        /* 隐藏IE滚动条 */
        // padding-top: 12px;
        // background-color: #ffffff;

        .menu_box {
          flex: 0 0 25%;
          box-sizing: border-box;
          overflow: hidden;
          position: relative;
          // user-select: none;

          .text {
            height: 38px;
            line-height: 38px;
            text-align: center;
            font-weight: 400;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.7);
          }

          .baseline {
            width: 20px;
            height: 3px;
            margin: 0 auto;
            position: absolute;
            bottom: 0;
            left: 15px;
          }

          &.active {
            .text {
              color: rgba(255, 255, 255, 1);
              font-weight: 600;
            }

            .baseline {
              background-color: rgba(255, 255, 255, 1);
            }
          }
        }
      }

      .parent-menu_outer_box::-webkit-scrollbar {
        display: none;
      }
    }

    .course_list_box {
      width: 200px;
      background: #fff;
      border-radius: 0px 0px 10px 10px;
      padding: 10px 0;
      box-sizing: border-box;
      height: 322px;
      overflow-y: auto;
      overflow-x: hidden;

      .course_one {
        width: 200px;
        height: 38px;
        line-height: 38px;
        color: RGBA(17, 17, 17, 1);
        padding-left: 18px;
        box-sizing: border-box;

        .course_one_text {
          width: 100%;
        }
      }

      .active_back {
        background: rgba(19, 214, 170, 0.1);
        color: rgba(19, 214, 170, 1);
      }
    }

    .subject_benefits {
      position: absolute;
      left: 200px;
      top: 0;
      width: 738px;
      height: 360px;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #13d6aa;
      z-index: 88;
      box-sizing: border-box;
      padding: 15px 20px;
      overflow: scroll;

      .benefits_title {
        font-size: 18px;
        font-weight: 600;
      }

      .publish_one {
        margin-right: 30px;
      }

      .selected_active {
        color: #13d6aa;
      }
    }
  }

  .top_banner_center {
    width: 780px;
    // height: 360px;

    :deep(.el-carousel) {
      width: 100%;
      height: 100%;
    }

    :deep(.el-carousel__container) {
      width: 100%;
      height: 100%;
    }
  }

  .top_banner_right_new {
    .task_box {
      background-image: url("/public/static/img/task_bg.png");
      width: 184px;
      height: 90px;

      .task_title {
        font-weight: 600;
        font-size: 17px;
        color: #ffffff;
      }

      .task_btn {
        width: 66px;
        height: 28px;
        line-height: 28px;
        background: #ffffff;
        border-radius: 14px;
        font-size: 14px;
        color: #ff5b69;
        font-weight: 600;
        text-align: center;
      }
    }
  }

  .top_banner_right {
    width: 184px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    padding: 12px;
    height: 250px;

    .top_banner_right_top {
      color: rgba(102, 102, 102, 1);
      height: 140px;
      border-bottom: 1px solid rgba(17, 17, 17, 0.1);
      box-sizing: border-box;

      .register_text {
        margin-left: 12px;
      }
    }

    .top_banner_right_bottom {
      .newest_course {
        font-weight: bold;
        font-size: 18px;
        color: #111111;
      }

      .active_normal {
        font-size: 16px;
        color: #606060;
      }

      .active_course {
        font-size: 16px;
        color: #13d6aa;
      }
    }
  }
}

.hot_sell_course {
  width: 100%;
  background: #ffffff;
  padding: 30px 0;

  .hot_sell_course_top {
    width: $pageMainWidth;

    .hot_sell_course_top_title {
      font-weight: bold;
      font-size: 24px;
      color: #000000;
    }

    .hot_course_text {
      color: #999999;
      margin-left: 26px;
      transition: color 0.2s ease;

      &:hover {
        color: #13d6aa;
      }
    }

    .active_text {
      color: #13d6aa;
    }
  }

  .more_btn {
    // width: 70px;
    // height: 35px;
    padding: 5px 10px;
    background: #f5f6f8;
    border-radius: 18px;
    color: rgba(153, 153, 153, 1);
  }
}

.course_rank {
  width: 100%;
  background: #ffffff;
  padding: 30px 0;
  background: rgba(243, 243, 243, 1);

  .week_course_rank {
    width: $pageMainWidth;
    font-weight: bold;
    font-size: 24px;
    color: #000000;

    .more_btn {
      width: 120px;
      height: 35px;
      background: #eaeef0;
      border-radius: 18px;
      color: rgba(153, 153, 153, 1);
      font-size: 16px;
      font-weight: normal;
    }
  }
}
</style>
